<template>
    <div class="infobox" v-bind:class="{ 'd-none': !visible }" ref="box">
        <div class="infobox-header pb-0" v-on:click="hide">
            <div class="infobox-close"></div>
            <div class="infobox-title hyphens-auto">
                <h2><slot name="title"></slot></h2>

            </div>
            <div class="infobox-subline" v-if="$slots.subline">
                <p class="mb-0"><slot name="subline"></slot></p>
            </div>
        </div>
        <div class="infobox-body">
            <!--            <div class="keyline"></div>-->
            <div class="overflow-area pt-1" ref="content">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { defineProps, ref, inject } from 'vue';

    const props = defineProps({
        modalName: String
    });

    let visible = ref(false);

    const eventBus = inject('$eventBus');
    const tracking = inject('$tracking');

    function hide()
    {
        eventBus.$emit('InfoBox.show', false);
    }

    import useDetectCanvasClick from '../tools/useDetectCanvasClick';
    const box = ref();
    useDetectCanvasClick(box, () => {
        hide();
    });

    eventBus.$on('InfoBox.show', (value) =>
    {
        if (visible.value && value !== props.modalName)
        {
            tracking.actionClick('info', 'schliessen ' + props.modalName);
        }

        visible.value = (value === props.modalName);
    });
</script>

<style scoped lang="scss">

</style>
